import axiosClient from "./AxiosClient";

class PermissionService {
  static getPermissions() {
    return axiosClient.get("/permissions");
  }
}

export default PermissionService;
